<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user.avatar" />
        }
        @if (!showAvatar || !user.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
<!--        <span-->
<!--            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"-->
<!--            [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,-->
<!--                          'bg-green-500': user.status === 'online',-->
<!--                          'bg-amber-500': user.status === 'away',-->
<!--                          'bg-red-500': user.status === 'busy',-->
<!--                          'bg-gray-400': user.status === 'not-visible'}"-->
<!--        ></span>-->
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{user.username}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="changePassword()">
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Change password</span>
    </button>
    @if(false) {
        <button mat-menu-item>
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span>Profile</span>
        </button>
        <button mat-menu-item>
            <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
            <span>Settings</span>
        </button>
        <button mat-menu-item>
            <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
            <span>Change user</span>
        </button>
    }
    <button
        mat-menu-item
        [matMenuTriggerFor]="unitSystemMenu">
        <mat-icon [svgIcon]="'heroicons_outline:scale'"></mat-icon>
        <span>Measurement units</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<mat-menu class="unit-system-menu" #unitSystemMenu="matMenu">
    <button mat-menu-item (click)="setUnitSystem('international')">
        <mat-icon [svgIcon]="'heroicons_outline:globe-alt'"></mat-icon>
        <span>International</span>
        @if (isUnitSystemSelected('international')) {
            <mat-icon class="ml-auto icon-size-5" [svgIcon]="'heroicons_outline:check'"></mat-icon>
        }
    </button>
    <button mat-menu-item (click)="setUnitSystem('imperial')">
        <mat-icon [svgIcon]="'heroicons_outline:map'"></mat-icon>
        <span>Imperial</span>
        @if (isUnitSystemSelected('imperial')) {
            <mat-icon class="ml-auto icon-size-5" [svgIcon]="'heroicons_outline:check'"></mat-icon>
        }
    </button>
</mat-menu>
